import React from 'react';
import {useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {API_ROOT} from '../../../../utils';
import Button from "../../../button/index";
import Popup from "../..";
import Icon from '../../../icon';
import {directoryWriteErrorPopup} from '../../../../../actions/popupActions';

function DirectoryWriteErrorPopup (props) {

	const { plan } = props;

	const { t } = useTranslation();

	const dispatch = useDispatch();

    const closeHandler = () => {
	    dispatch(directoryWriteErrorPopup(false));
    };

    if(plan !== "FREE_EDITION" && plan !== "BUSINESS"){
	    return (
		    <Popup className="p-4" onClose={closeHandler}>
			    <h2 className="text-danger"><Icon name="times" className="mr-1"/>{t("directoryWriteErrorPopup.insufficientEdition.title")}</h2>
			    <p>{t("directoryWriteErrorPopup.insufficientEdition.description")}</p>
			    <div className="text-right">
				    <a role="button" href={`${API_ROOT}/payment/upgrade`} onClick={closeHandler} className="btn btn-primary">{t("textUpgradeNow")}</a>
			    </div>
		    </Popup>
	    );
    } else {
	    return (
		    <Popup className="p-4" unclosable={true}>
			    <h2 className="text-danger"><Icon name="times" className="mr-1"/>{t("directoryWriteErrorPopup.permissionError.title")}</h2>
			    <p>{t("directoryWriteErrorPopup.permissionError.description")}</p>
			    <div className="text-right">
				    <Button onClick={closeHandler} className="btn-primary">{t('okText')}</Button>
			    </div>
		    </Popup>
	    );
    }

}


export default DirectoryWriteErrorPopup;
